import { useTranslate } from '@va/localization';
import { fontWeights, Paragraph, ToggleActionCard } from '@va/ui/design-system';
import { useCallback } from 'react';
import { useEditConsentForAiModel } from '../api';
import { getAiModelIcon } from '../helpers';
import { useAiChatbotContext } from './aiChatbotContext';

export const AiChatbotModelSettings = () => {
  const translate = useTranslate();
  const {
    aiModels: { data: aiModels, mutate: mutateAiModels },
  } = useAiChatbotContext();

  const { execute: editConsent } = useEditConsentForAiModel();

  const handleChange = useCallback(
    async ({ name, value }: { name: string; value: boolean }) => {
      await editConsent(name, value);
      mutateAiModels();
    },
    [editConsent, mutateAiModels],
  );

  return (
    <div className='w-full rounded-6u overflow-hidden'>
      {aiModels?.map((aiModel) => (
        <ToggleActionCard
          wrapperClass='rounded-none mb-1u last:mb-0'
          contentClassName='!gap-4u'
          size='small'
          key={aiModel.name}
          name={aiModel.name}
          title={aiModel.name}
          value={aiModel.consented}
          icon={() => getAiModelIcon(aiModel.name)}
          switchOnColor={window.PRIMARY_COLOR}
          endAdornment={
            aiModel.default ? (
              <Paragraph
                weight={fontWeights.medium}
                className='text-interface-regular leading-interface-regular text-gray-tundora'
              >
                {translate('aiChatbot.modelSettings.defaultModel')}
              </Paragraph>
            ) : undefined
          }
          handleChange={handleChange}
        />
      ))}
    </div>
  );
};
